import { PlaygroundParameters, PlaygroundState, SavedSession } from "./types";

export function serializeParameters(state: PlaygroundState): SavedSession["parameters"] {
    const serialize = (p: PlaygroundParameters) => ({
        max_tokens: p.maxTokens, temperature: p.temperature, top_p: p.topP,
    });
    return {
        ...serialize(state.parameters),
        ...(state.mode === "compare-prompts" ? {
            prompt_parameters: state.userMessages.map((_, i) => serialize(state.promptParameters[i] ?? state.parameters)),
        } : {}),
    };
}

export function deserializeParameters(saved?: SavedSession["parameters"]) {
    const read = (p?: { max_tokens?: number; temperature?: number; top_p?: number }): PlaygroundParameters => ({
        maxTokens: p?.max_tokens ?? 1024,
        temperature: p?.temperature ?? 0.7,
        topP: p?.top_p ?? 0.95,
        stoppingTokens: [],
    });
    return { parameters: read(saved), promptParameters: saved?.prompt_parameters?.map(read) };
}
